import { ListService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  AssetDetailsDto,
  AssetService,
  AssetTransferableParts,
} from '@proxy/register-service/assets';
import { LocationService } from '@proxy/register-service/locations';
import { DeallocationType } from '@register/proxy/register-service/assets';
import { LocationDefinition } from '@register/proxy/register-service/locations';

@Component({
  selector: 'app-allocate-modal',
  templateUrl: './allocate-modal.component.html',
  styleUrls: ['./allocate-modal.component.scss'],
})
export class AllocateModalComponent implements OnChanges {
  @Input() openAllocateModal: boolean;
  @Input() asset: AssetDetailsDto;
  @Input() showMessage = false;
  @Input() twoStepEnabled = false;
  @Input() transferData: AssetTransferableParts | null = null;
  @Input() assets: string[];
  @Input() pinOrKeyringPassword: string = '';
  @Input() isGuest: boolean = false;

  @Output() modalClose = new EventEmitter<boolean>();
  @Output() openTransferModal = new EventEmitter();

  DeallocationType = DeallocationType;
  selectedLocationsIds: string[] = [];
  locationDefinition: LocationDefinition = LocationDefinition.JOBSITE;
  isBusy: boolean = true;
  notes = '';
  private pendingAllocate = false;
  constructor(
    public readonly list: ListService,
    public readonly service: LocationService,
    public readonly assetService: AssetService,
    public readonly toasterService: ToasterService
  ) {}

  selectLocations(locationIds: string[]) {
    this.isBusy = false;
    this.selectedLocationsIds = locationIds;
  }

  performAction() {
    this.isBusy = true;
    const allocate = this.assetService.performAction({
      actionType: 'allocate',
      asset: this.asset,
      assetIds: this.assets,
      transferData: this.transferData,
      selectedLocationsIds: this.selectedLocationsIds,
      pinOrKeyringPassword: this.pinOrKeyringPassword,
      transferNotes: this.notes,
    });

    allocate.subscribe({
      next: () => {
        this.modalClose.emit(true);
        this.toasterService.success('RegisterService::Successful');
      },
    });
  }

  allocate() {
    const hasTransfer = this.transferData && Object.keys(this.transferData).length > 0;
    if (this.twoStepEnabled && this.asset.hasSubAssets && !hasTransfer) {
      this.pendingAllocate = true;
      this.openTransferModal.emit();
    } else {
      this.performAction();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['transferData'] &&
      this.pendingAllocate &&
      this.transferData &&
      Object.keys(this.transferData).length > 0
    ) {
      this.pendingAllocate = false;
      this.performAction();
    }
  }
}
